<template>
  <div>
    <telephony-operators-report-header @generate="generate" @filterChanged="filterChanged"
    @onChangedDateStart="onChangedDateStart" @onChangedDateEnd="onChangedDateEnd"
    :filterOptions="filterOptions" :isGenerateDisabled="isGenerateDisabled" @paginationChanged="paginationChanged"/>

    <basic-table
      :items="reportUsers"
      :fields="reportUsersFields"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"/>
    <table-manager-bottom
    :totalRows="totalRows" :perPage="perPage"
    v-model="currentPage"/>
  </div>
</template>

<script>

export default {
  props: {
    editItem: null
  },
  data () {
    return {
      num: 0,
      reportUsers: [],
      reportUsersFields: [
        {key: 'num', label: this.$i18n.t('Row number'), sortable: true},
        {key: 'w', label: this.$i18n.t('Contract number'), sortable: true},
        {key: 'user_login', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'r', label: this.$i18n.t('Legal address'), sortable: true},
        {key: 't', label: this.$i18n.t('INN'), sortable: true},
        {key: 'y', label: this.$i18n.t('KPP'), sortable: true},
        {key: 'u', label: this.$i18n.t('Diplomat'), sortable: true},
        {key: 'i', label: this.$i18n.t('Juridical status'), sortable: true},
        {key: 'a', label: this.$i18n.t('Resident'), sortable: true},
        {key: 's', label: this.$i18n.t('Nationality'), sortable: true},
        {key: 'charge_date', label: this.$i18n.t('Begin contract date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'charge_duration', label: this.$i18n.t('End contract date'), sortable: true, formatter: (val, key, item) => { return this.$root.showDataWithTZDelta(val) }},
        {key: 'g', label: this.$i18n.t('Contract type'), sortable: true},
        {key: 'h', label: this.$i18n.t('Contract place'), sortable: true},
        {key: 'j', label: this.$i18n.t('User agreement'), sortable: true}
      ],
      isGenerateDisabled: false,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      dateStart: this.$root.setDataWithSelectedTZ().toDate(),
      dateEnd: this.$root.setDataWithSelectedTZ().toDate(),
      currentTab: 1,
      filterOptions: {
        isFilterGroup: false,
        isFilterTypeTraffic: false,
        isFilterTypeDocuments: false,
        isFilterTypeUsers: false,
        isFilterCollector: false
      }
    }
  },
  methods: {
    async generate () {
      this.num = 0
      this.isGenerateDisabled = true
      let generate = {
        numDateEnd: 0,
        numDateStart: 0,
        supplier_id: 0
      }
      generate.numDateEnd = Number(this.dateEnd) / 1000
      if (generate.numDateEnd > 2147483647) generate.numDateEnd = 2147483647
      generate.numDateStart = Number(this.dateStart) / 1000
      if (generate.numDateStart > 2147483647) generate.numDateStart = 2147483647
      generate.supplier_id = this.editItem.id
      let reportUsers = await this.$store.dispatch('Settings/GET_REPORT_USERS', generate)
      this.reportUsers = reportUsers.data
      for (let el of this.reportUsers) {
        el.num = ++this.num
        el.charge_duration += el.charge_date
      }
      this.loadDone()
    },
    onChangedDateStart (value) {
      this.dateStart = value
    },
    onChangedDateEnd (value) {
      this.dateEnd = value
    },
    filterChanged (value) {
      this.filter = value
    },
    loadDone () {
      this.isGenerateDisabled = false
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  mounted () {
    this.loadDone()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/telephony/telephoneOperators/reportUsers.vue